import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={10 * (props.wx ?? 1)}
    height={30 * (props.hx ?? 1)}
    viewBox="0 0 10 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M1.80574 9.61588C1.95076 10.3014 2.13909 10.7189 2.37748 11.1761C2.59323 11.5902 2.79428 11.9285 2.82686 12.4157C3.02313 15.3321 3.74308 20.4307 3.86187 24.5672C3.9767 28.5742 4.82816 29.3615 5.25091 29.3233C5.71935 29.2808 5.76186 27.5309 6.25057 24.861C6.77503 21.9943 7.00031 20.415 7.30029 18.3909C7.63404 16.1371 7.64636 14.9275 7.86091 13.4466C7.9809 12.6192 8.06553 12.0746 8.17519 11.6581C8.3079 11.1546 8.38537 10.9176 8.65079 10.385C9.16293 9.35744 9.58568 4.86745 8.81329 3.52031C8.34485 2.70343 8.05163 2.35422 7.37499 2.1254C6.94866 1.98161 6.01099 1.341 5.29541 1.32524C4.62235 1.30995 4.07206 1.56505 3.11015 1.89945C2.45457 2.12731 2.08426 2.28018 1.62257 2.99197C0.863293 4.16331 1.39054 7.65488 1.80574 9.6154V9.61588Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNormal;
